import React from 'react';
import { deadlineFor, dayWords } from '../../lib/licences';

/**
 * THE NOTICE PERIOD AND ITS REMINDER (130, wave 7), on the licence form and
 * the contract form alike: "Notice period [3] [months]" and "Remind me [__]
 * days before the notice deadline" (empty: 30, when there is a period), with
 * the deadline the dates above would give spelt out under them. The server
 * works the deadline out again (lib/notice-alerts.js) - this is only so the
 * person filling it in sees what they are agreeing to.
 *
 * `ready` is the options' `notice`: false before migration 130, when the
 * licence form says it needs the migration, and the contract form keeps its
 * period in days only and offers no reminder. `prefix` keeps the ids apart.
 */
export default function NoticeFields({ form, set, ready, prefix = 'lic', daysOnly = false }) {
  const shown = deadlineFor(form);
  const period = form.notice_amount !== '' && Number(form.notice_amount) > 0;
  if (!ready && !daysOnly) {
    return (
      <div className="lic-field lic-field-wide">
        <span className="lic-field-label">Notice period</span>
        <p className="lic-hint" data-testid="notice-needs-migration">Notice periods need migration 130 on the server (npm run migrate:130).</p>
      </div>
    );
  }
  return (
    <>
      <div className="lic-field">
        <label htmlFor={`${prefix}-notice`}>Notice period</label>
        <div className="lic-notice">
          <input id={`${prefix}-notice`} type="number" inputMode="numeric" min="0" step="1" value={form.notice_amount}
            onChange={set('notice_amount')} placeholder="None" />
          <select aria-label="Notice period in" value={ready ? form.notice_unit : 'days'} onChange={set('notice_unit')} disabled={!ready}>
            <option value="days">days</option>
            <option value="months">months</option>
          </select>
        </div>
        <p className="lic-hint" data-testid={`${prefix}-notice-deadline`}>
          {!period ? 'How long before the renewal or end notice has to be given. Leave empty for none.'
            : shown ? `Give notice by ${dayWords(shown.deadline)} - before the ${shown.kind === 'end' ? 'end' : 'renewal'} on ${dayWords(shown.on)}.`
              : 'The deadline is worked out from the renewal or end date - add one.'}
        </p>
      </div>
      <div className="lic-field">
        <label htmlFor={`${prefix}-alert`}>Remind me</label>
        <div className="lic-notice">
          <input id={`${prefix}-alert`} type="number" inputMode="numeric" min="0" max="365" step="1" value={form.notice_alert_days}
            onChange={set('notice_alert_days')} placeholder="30" disabled={!ready || !period} />
          <span className="lic-notice-words">days before the notice deadline</span>
        </div>
        <p className="lic-hint">
          {ready ? 'Once per term, in the bell and by email if you turn it on (Notifications). Empty is 30 days.'
            : 'The reminder needs migration 130 on the server.'}
        </p>
      </div>
    </>
  );
}
